import { Action } from '@ngrx/store';

import { User } from '@core/objects/user';
import { Organization } from '@core/objects/organization';
import { AccountSession } from '@core/objects/account-session';
import { Session } from '@app/store/models/session.model';
import { AccessItem } from '@app/store/models/access-item.model';

export enum AppActionTypes {
    LoadSessionRequest = '[App] Load Session request',
    LoadSessionSuccess = '[App] Load Session success',
    LoadAccountSessionSuccess = '[App] Load Account Session success',
    LoadAccountSessionError = '[App] Load Account Session error',
    SetVersion = '[App] Set Version',
    Disconnected = '[App] Disconnected',
    ChangeOrganization = '[App] Set Organization',
    UpdateUser = '[App] PUT - Save User',
    UpdateUserSuccess = '[App] Save User success',
    UpdateUserError = '[App] Save User error',
    // UpdateOrganization = '[App] PUT - Save Organization',
    UpdateOrganizationSuccess = '[App] Save Organization success',
    // UpdateOrganizationError = '[App] Save Organization error',
}

export class LoadSessionRequest implements Action {
    readonly type = AppActionTypes.LoadSessionRequest;
    constructor() {}
}

export class LoadSessionSuccess implements Action {
    readonly type = AppActionTypes.LoadSessionSuccess;
    constructor(public payload: Session) {}
}

export class LoadAccountSessionSuccess implements Action {
    readonly type = AppActionTypes.LoadAccountSessionSuccess;
    constructor(public payload: AccountSession) {}
}

export class LoadAccountSessionError implements Action {
    readonly type = AppActionTypes.LoadAccountSessionError;
    constructor() {}
}

export class SetVersion implements Action {
    readonly type = AppActionTypes.SetVersion;
    constructor(public version: string) {}
}

export class Disconnected implements Action {
    readonly type = AppActionTypes.Disconnected;
    constructor() {}
}

export class ChangeOrganization implements Action {
    readonly type = AppActionTypes.ChangeOrganization;
    constructor(public organization: any) {}
}

export class UpdateUser implements Action {
    readonly type = AppActionTypes.UpdateUser;
    constructor(public name: string) {}
}

export class UpdateUserSuccess implements Action {
    readonly type = AppActionTypes.UpdateUserSuccess;
    constructor(public user: User) {}
}

export class UpdateUserError implements Action {
    readonly type = AppActionTypes.UpdateUserError;
    constructor() {}
}
// export class UpdateOrganization implements Action {
//     readonly type = AppActionTypes.UpdateOrganization;
//     constructor(public name: string) {}
// }

export class UpdateOrganizationSuccess implements Action {
    readonly type = AppActionTypes.UpdateOrganizationSuccess;
    constructor(public organization: Organization) {}
}

// export class UpdateOrganizationError implements Action {
//     readonly type = AppActionTypes.UpdateOrganizationError;
//     constructor() {}
// }

export type AppActions = LoadSessionRequest |
                         LoadSessionSuccess |
                         LoadAccountSessionSuccess |
                         LoadAccountSessionError |
                         SetVersion |
                         Disconnected | 
                         ChangeOrganization | 
                         UpdateUser | 
                         UpdateUserSuccess | 
                         UpdateUserError |
                        //  UpdateOrganization | 
                         UpdateOrganizationSuccess; // | 
                        //  UpdateOrganizationError;

